const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export const generateBarcodeValue = (length = 10): string => {
  const cryptoSource = window.crypto;
  const out = new Array<string>(length);

  if (cryptoSource?.getRandomValues) {
    const buffer = new Uint32Array(length);
    cryptoSource.getRandomValues(buffer);
    for (let i = 0; i < length; i++) {
      out[i] = ALPHABET[buffer[i] % ALPHABET.length];
    }
  } else {
    for (let i = 0; i < length; i++) {
      out[i] = ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
    }
  }

  return out.join("");
};
